import React, { useEffect, useState } from 'react';
import './index.css';

export function WhatsAppButton({ number, message, isView }) {

    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {

        if (!isView) return;

        const checkToasts = () => {

            const activeToast = document.querySelector('.Toastify__toast');

            if (activeToast) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
        };

        const observer = new MutationObserver(checkToasts);

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        checkToasts();

        return () => {
            observer.disconnect();
        };
    }, [isView]);

    const whatsappUrl = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

    return isView && (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="cw-fab cw-whatsapp"
            aria-label="Contactar por WhatsApp"
            style={{
                display: isVisible ? 'flex' : 'none',
                visibility: isVisible ? 'visible' : 'hidden',
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.3s ease-in-out'
            }}
        >
            <WhatsAppIcon />
        </a>
    );
}

function WhatsAppIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="28"
            height="28"
            fill="white"
            aria-hidden="true"
        >
            <path d="M16 0C7.163 0 0 7.163 0 16c0 2.833.742 5.634 2.153 8.106L0 32l8.1-2.124A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.784-1.858l-.486-.29-5.03 1.318 1.34-4.893-.317-.502A13.226 13.226 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.815c-.398-.199-2.354-1.162-2.719-1.294-.365-.133-.63-.199-.896.199-.265.398-1.029 1.294-1.261 1.56-.232.265-.464.298-.863.1-.398-.2-1.682-.62-3.203-1.977-1.184-1.057-1.983-2.362-2.215-2.76-.232-.398-.025-.613.174-.811.179-.178.398-.464.597-.696.2-.232.266-.398.399-.663.132-.265.066-.497-.033-.696-.1-.199-.896-2.16-1.228-2.957-.323-.777-.651-.672-.896-.684l-.763-.013c-.265 0-.696.1-1.061.497-.365.398-1.394 1.362-1.394 3.322s1.427 3.854 1.626 4.12c.2.265 2.808 4.287 6.804 6.012.951.41 1.693.655 2.271.839.954.304 1.823.261 2.51.158.766-.114 2.354-.962 2.686-1.892.332-.93.332-1.727.232-1.892-.099-.166-.364-.265-.763-.464z" />
        </svg>
    );
}